import type { IComponentOptions } from "angular";
import { module } from "angular";

import EventsTimeLineComponentController from "./EventsTimeLineComponentController";

import "./EventsTimeLine.html";
import "./EventsTimeLine.scss";
import "./SetDatePositionDirective";

export default class EventsTimeLineComponent implements IComponentOptions {
    public templateUrl = "/App/Components/Site/Events/EventsTimeLine/EventsTimeLine.html";

    public bindings = {
        dateFrom: "<",
        dateTo: "<",
        events: "<",
        functionalities: "<",
        issues: "<",
        site: "<",
        siteEquipment: "<",
    };

    public controller = EventsTimeLineComponentController;
}

module("mmGui").component("irEventsTimeLine", new EventsTimeLineComponent());
